import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'
import { Props_SnippetStatisticsIcon } from './StatisticsIcon.props'

const StatisticsIcon = (props: Props_SnippetStatisticsIcon) => {
    const { snippet, heading, repeatable_entries } = props

    const classHeadingVisibility: string = heading.visibility.value ? `snippet-statistics__heading--${heading.visibility.value}` : ''
    const classSnippetTheme = `snippet-statistics--theme-${snippet.theme?.value}`

    return (
        <section className={`snippet-statistics ${classSnippetTheme}`}>
            <div className="snippet-statistics__container">
                <h2 className={`snippet-statistics__heading ${classHeadingVisibility}`}>{ heading.content.value }</h2>
                <div className="snippet-statistics__container-entries">
                    { repeatable_entries.map((entry, index) =>  (
                        <div key={index} className="snippet-statistics__entry">
                            { entry.icon?.value && <img
                                loading="lazy"
                                src={entry.icon.value}
                                alt=""
                                className="snippet-statistics__entry-icon"
                                height="70"
                                width="70"
                            ></img> }
                            { entry.content?.value && <div className="snippet-statistics__entry-content">{ Legacy_CompileMarkdown(entry.content.value) }</div> }
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default StatisticsIcon
